import * as tslib_1 from "tslib";
import * as React from 'react';
import * as dayjs from 'dayjs';
import { inject, observer } from 'mobx-react';
import DayOffsApi from '../../services/DayOffsApi';
import DayOffsCalendar from './DayOffsCalendar';
import Main from 'src/layout/Main';
import '../../css/dayoff.css';
var styles = {
    input: {
        margin: '.2rem',
        border: '1px solid #ddd',
        width: '200px',
        outline: 'none',
        borderRadius: '3px',
        padding: '.25rem .5rem'
    }
};
var DayOffsPage = /** @class */ (function (_super) {
    tslib_1.__extends(DayOffsPage, _super);
    function DayOffsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            date: dayjs().toDate(),
            dayOffs: [],
            filteredDayOffs: null
        };
        _this.componentWillMount = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.load = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var date, startDate, endDate, dayOffs;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        date = this.state.date;
                        startDate = dayjs(date).startOf('month').toDate();
                        endDate = dayjs(date).endOf('month').toDate();
                        return [4 /*yield*/, DayOffsApi.getAll(startDate, endDate)];
                    case 1:
                        dayOffs = _a.sent();
                        this.setState({ dayOffs: dayOffs });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onDateChange = function (e) {
            _this.setState({ date: e.activeStartDate, filteredDayOffs: null }, function () { return _this.load(); });
        };
        _this.onFilterChange = function (e) {
            var filterText = (e.target.value || '').toLocaleLowerCase();
            if (!filterText) {
                _this.setState({ filteredDayOffs: null });
                return;
            }
            var filteredDayOffs = _this.state.dayOffs.filter(function (d) { return (d.user.toLocaleLowerCase().includes(filterText) ||
                d.description.toLocaleLowerCase().includes(filterText)); });
            _this.setState({ filteredDayOffs: filteredDayOffs });
        };
        return _this;
    }
    DayOffsPage.prototype.render = function () {
        return (React.createElement(Main, null,
            React.createElement("div", { style: { padding: '1rem' } },
                React.createElement("input", { placeholder: "Sz\u0171r\u00E9s", onChange: this.onFilterChange, style: styles.input })),
            React.createElement(DayOffsCalendar, { items: this.state.filteredDayOffs || this.state.dayOffs, onDateChange: this.onDateChange })));
    };
    DayOffsPage = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], DayOffsPage);
    return DayOffsPage;
}(React.Component));
export default DayOffsPage;



//////////////////
// WEBPACK FOOTER
// ./src/pages/dayoffs/DayOffsPage.tsx
// module id = 789
// module chunks = 0